var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('edit-sheet-real',{attrs:{"dispatchId":_vm.dispatchId,"loadOrderId":_vm.loadOrderId,"canEdit":true,"op":_vm.op},on:{"reset":_vm.reset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }